export default {
  ExpenseRegular: 2, // chi thường xuyên
  ExpenseProgram: 3, // chi CTMT
  ExpenseFees: 4, // Chi phí, lệ phí
  ExpenseBusiness: 5, // Chi từ nguồn HĐSNDV,
  RevenueBusiness: 7, // thu HĐSNDV
};